export default __webpack_public_path__ + "static/media/enyo.69c0e576.svg";